export { HasIntersectionPipe } from './has-intersection.pipe';

